// Calculate height of WP admin bar and store it as a css variable
window.addEventListener("load", function () {
    const wpadminbar = document.getElementById("wpadminbar");
    const header = document.querySelector("header.wp-block-template-part");
    if (wpadminbar) {
        const height = wpadminbar.clientHeight;
        document.documentElement.style.setProperty("--wpadminbar-height", `${height}px`);
    }
    if (header) {
        const height = header.clientHeight;
        document.documentElement.style.setProperty("--header-height", `${height}px`);
    }
});

// If the page has scrolled down more than 10px, add a 'has-scrolled' class to the body. Remove the class again when we scroll back up to within 10px of the top.
// This is useful for styling elements differently when the page has been scrolled.
function addHasScrolledClass() {
    window.scrollY > 10 ? document.body.classList.add("has-scrolled") : document.body.classList.remove("has-scrolled");
}
window.addEventListener("load", addHasScrolledClass);
window.addEventListener("scroll", addHasScrolledClass);

document.addEventListener('DOMContentLoaded', function () {
	const body = document.body;
	const menu = document.getElementById('primary-menu');
	const searchForm = document.querySelector('.masthead .search-form');
	const navToggle = document.getElementById('nav-toggle');

	// Mobile menu toggle
	navToggle.addEventListener('click', function () {
		const expanded = this.getAttribute('aria-expanded') === 'true' || false;
		this.setAttribute('aria-expanded', !expanded);
		this.classList.toggle('is-open');
		menu.classList.toggle('is-open');
		body.classList.toggle('drawer-is-open');
	});

	// Sub-menu toggling
	document.querySelectorAll('#primary-menu .menu-item-has-children > a').forEach(parentLink => {
		parentLink.addEventListener('click', function (e) {
			e.preventDefault();

			// Close all other submenus
			document.querySelectorAll('#primary-menu .submenu-open').forEach(item => {
				if (item !== this.parentNode) {
					item.classList.remove('submenu-open');
				}
			});

			// Toggle this submenu
			this.parentNode.classList.toggle('submenu-open');
		});
	});

	// Global click handler to close open elements
	document.addEventListener('click', function (e) {
		const clickedInsideMenu = e.target.closest('#primary-menu');
		const clickedNavToggle = e.target.closest('#nav-toggle');

		// Close submenus if click outside menu
		if (!clickedInsideMenu) {
			document.querySelectorAll('#primary-menu .submenu-open').forEach(item => {
				item.classList.remove('submenu-open');
			});
		}

		// Close mobile menu if open and click outside
		if (!clickedInsideMenu && !clickedNavToggle && menu.classList.contains('is-open')) {
			menu.classList.remove('is-open');
			navToggle.classList.remove('is-open');
			navToggle.setAttribute('aria-expanded', 'false');
			body.classList.remove('drawer-is-open');
		}
	});
});

document.addEventListener('DOMContentLoaded', () => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        // Do not initialize type effect
        return;
    }
    class TypeOnEffect {
      constructor(element) {
        this.el = element;
        this.nouns = element.dataset.nouns.split(',').map(n => n.trim());
        this.speed = parseInt(element.dataset.speed, 10) || 50;
        this.delay = parseInt(element.dataset.delay, 10) || 2000;
  
        this.nounSpan = element.querySelector('.noun');
        this.index = 0;
        this.currentText = '';
        this.isDeleting = false;
  
        this.type();
      }
  
      type() {
        const fullText = this.nouns[this.index];
        const nextCharIndex = this.currentText.length + (this.isDeleting ? -1 : 1);
  
        this.currentText = fullText.substring(0, nextCharIndex);
        this.nounSpan.textContent = this.currentText; 
  
        let timeout = this.speed;
  
        if (!this.isDeleting && this.currentText === fullText) {
          timeout = this.delay;
          this.isDeleting = true;
        } else if (this.isDeleting && this.currentText === '') {
          this.isDeleting = false;
          this.index = (this.index + 1) % this.nouns.length;
          timeout = this.speed;
        }
  
        setTimeout(() => this.type(), timeout);
      }
    }
  
    // Init all type-on elements
    document.querySelectorAll('.type-on').forEach(el => new TypeOnEffect(el));
  });
  

// Append 'loaded' class to images when they are fully loaded
document.addEventListener('DOMContentLoaded', function () {
    const images = document.querySelectorAll('img');

    images.forEach(img => {
        if (img.complete && img.naturalHeight !== 0) {
        img.classList.add('loaded');
        } else {
        img.addEventListener('load', () => {
            img.classList.add('loaded');
        });
        img.addEventListener('error', () => {
            img.classList.add('loaded'); // Optionally handle error cases too
        });
        }
    });
});
  

document.addEventListener('DOMContentLoaded', () => {
const shareButtons = document.querySelectorAll('[data-function="share"]');

const hostname = location.hostname;
const isLocalhost =
hostname === 'localhost' ||
hostname === '127.0.0.1' ||
hostname.endsWith('.local');

if (!navigator.share) {
	if (!isLocalhost) {
	// In production, hide share buttons if not supported
	console.log('Hiding share buttons as navigator.share is not supported.');
	shareButtons.forEach(button => {
		button.style.display = 'none';
	});
} else {
	console.log('Not hiding the share buttons since we\'re in dev.');
	// In local dev, attach fallback alert
	shareButtons.forEach(button => {
		button.addEventListener('click', () => {
		alert("Sharing isn't supported in this browser and/or environment. In production, the share button will be hidden.");
		});
	});
	}
	return;
}

// Attach real share handler if supported
shareButtons.forEach(button => {
	button.addEventListener('click', async () => {
	try {
		await navigator.share({
		title: document.title,
		url: window.location.href
		});
	} catch (err) {
		console.error('Sharing failed:', err);
	}
	});
});
});


// Enforce maxlenth on number fields
document.querySelectorAll('input[type="number"]').forEach(function (input) {
  const maxLength = input.getAttribute('maxlength');
  if (!maxLength) return;

  input.addEventListener('input', function () {
    if (this.value.length > maxLength) {
      this.value = this.value.slice(0, maxLength);
    }
  });
});

// GA tracking for Telegram link clicks and PDF downloads
document.addEventListener('click', function (event) {

	// console.log('Document clicked:', event.target);
  // Find the nearest <a> element in case clicking inside a child element
  const link = event.target.closest('a');
  if (!link) {
    return;
  }

  const href = link.href || '';

  // Exit early if gtag doesn't exist (eg. GA4 blocked)
  if (typeof gtag !== 'function') {
    // return;
  }

  // 1. Track Telegram link clicks (t.me domain)
  if (href.match(/^https?:\/\/(www\.)?t\.me\//i)) {
    if (typeof gtag == 'function') {
      gtag('event', 'telegram_click', {
        link_url: href
      });
    } else {
      console.log('GA not available, cannot track Telegram link click:', href);
    }
	  // console.log('Tracked Telegram link click:', href);
    return;
  }

  // 2. Track PDF downloads (ends with .pdf, case-insensitive)
  if (href.match(/\.pdf(\?|$)/i)) {
    let fileName = href.split('/').pop().split('?')[0];
    
    try {
      fileNameDecoded = decodeURIComponent(fileName);
    } catch (e) {
      console.warn('Failed to decode filename:', fileNameDecoded, fileName, e);
    }

    if (typeof gtag === 'function') {
      gtag('event', 'download', {
        file_name: fileName,
        file_name_decoded: fileNameDecoded,
        link_url: href
      });
      gtag('event', 'pdf_download', {
        pdf_name: fileName,
        pdf_name_decoded: fileNameDecoded,
        link_url: href
      });
    } else {
      console.log('GA not available, cannot track PDF download:', fileNameDecoded, fileName, href);
    }
  }
});